export enum Language {
  EN = "en",
  NL = "nl",
}
